package org.teddapp.project.db

import kotlin.js.Date

internal actual fun nowMillis(): Long = Date.now().toLong()
